<template>
    <div>
        <select class="input_s" v-model="interval">
            <option :value="5">{{ $t('reservationwindow.header.label_5_min_interval') }}</option>
            <option :value="10">{{ $t('reservationwindow.header.label_10_min_interval') }}</option>
            <option :value="15">{{ $t('reservationwindow.header.label_15_min_interval') }}</option>
            <option :value="20">{{ $t('reservationwindow.header.label_20_min_interval') }}</option>
            <option :value="30">{{ $t('reservationwindow.header.label_30_min_interval') }}</option>
            <option :value="60">{{ $t('reservationwindow.header.label_60_min_interval') }}</option>
        </select>
    </div>
</template>

<script>
import { setSelectedTimeInterval, sheetAxis } from '../../../sheet-axis'

export default {
    props: {
    },
    data() {
        return {
            sheetAxis,

            interval: 15
        }
    },
    watch: {
        interval: {
            handler: function(newValue) {
                setSelectedTimeInterval(newValue)
            }
        }
    },
    mounted() {
        this.initIntervalData()
    },
    computed: {
    },
    methods: {
        initIntervalData() {
            let time = this.sheetAxis.selectedTimeInterval ?? 15
            this.interval = time
        }
    }
}
</script>
